import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { FormTextField } from "@/components/UiKit"
import type { CustomerPurchaseOrderFormValues } from "@/screens/CustomerOrders/schemas"

interface AddCustomerPurchaseOrderFormProps {
  isDuplicate?: boolean
}

export const AddCustomerPurchaseOrderForm: FC<AddCustomerPurchaseOrderFormProps> = ({ isDuplicate = false }) => {
  const { control } = useFormContext<CustomerPurchaseOrderFormValues>()

  return (
    <FormTextField
      control={control}
      name='cpoNumber'
      label='CPO #'
      required
      data-testid='customer-orders.add-cpo-dialog.cpo-number-field'
      helperText={isDuplicate ? "This CPO already exists on the Customer Purchase Orders tab." : undefined}
      error={isDuplicate || undefined}
    />
  )
}
